
import security from "../../../main";
import Core from "@/modules/core/service/Core";
import { getApiBaseUrl } from "@/config";
import Clipboard from "@/modules/inc/service/private/Clipboard";
import Maintenance from "@/modules/inc/service/private/Maintenance";
import Vue from "vue";
import Documents from "@/modules/inc/service/private/Documents";
import Steps from "@/modules/inc/service/private/Steps";
import Types from "@/modules/inc/service/private/Types";
import Status from "@/modules/inc/service/private/Status";
import Todo from "@/modules/inc/service/private/Todo";
import Search from "@/modules/inc/service/private/Search";
import Outbox from "@/modules/inc/service/private/Outbox";
import Moderization from "@/modules/inc/service/private/Moderization";

const fullMaintenanceTypId = 2;

Vue.prototype.$incident = {
    events: {
        context: {
             // fired, before we leave an incident context (inciden and/or unit).
            leave  : "inc-context-leave",
            // fired, after we entered a new incident context (inciden and/or unit).
            entered: "inc-context-entered",
            // fired, when the user hast a new step selected
            stepChanged: "inc-context-step"
        },

        unit: {
            remove: "inc-remove-unit"
        },

        refresh: {
            maintenence: "inc-refresh-maintenance",
        },

        navigate : "inc-navigate",
        save     : "inc-save",
    }
};

export default {
    url: {
        create         : '/api/incident',
        incident       : "/api/incident/",
        incidentId     : "/api/incident/{0}",
        save           : "/api/incident/step",
        postponement   : "/api/incident/step/{0}/postponement",
        enums          : "/api/incident/enums",
        components     : "/api/incident/{id}/components/",
        recent         : "/api/incident/recents",
        history        : "/api/incident/{0}/history",
        unit           : "/api/incident/{0}/unit/{1}",
        assessment: {
            last  : "/api/incident/assessments/",
            top   : "/api/incident/assessments/{0}/top?count={1}"
        }
    },

    events: {
        notice : "inc-notice",
        journal: "inc-journal",
    },

    maintenance: Maintenance,
    modernization: Moderization,
    clipboard  : Clipboard,
    document   : Documents,
    step       : Steps,
    type       : Types,
    status     : Status,
    search     : Search,
    todo       : Todo,
    outbox     : Outbox,

    isFullMaintenance (incident) {
        const sites = incident.sites;

        if (!sites) {
            return false;
        }

        let fullMaintenance = true;
        sites.forEach(site => {
            if (site.mntTypeId !== fullMaintenanceTypId) {
                fullMaintenance = false;
            }
        });

        return fullMaintenance;
    },

    recents () {
        return Core.method.get(this.url.recent);
    },

    /**
     * Checks if bid processing is necessary.
     *
     * @param incident the incident to check.
     * @param data
     * @return {boolean|*}
     */
    isBidsNecessary (incident, data) {
        if (incident && (incident.typeId === 23 || incident.typeId === 24)){
            return true;
        }

        if (!this.isFullMaintenance(incident)) {
            return true;
        }

        return data.notIncludedInFullMaintenance;
    },

    isModernization (incident) {
        return incident && (incident.typeId === 23 || incident.typeId === 24);
    },

    create: function (component, sites, typeId, parameter, message, success, error) {
        Core.loading(component, true, message);
        Core.method.post(this.url.create, {
            sites    : sites,
            typeId   : typeId,
            parameter: parameter
        }).then((data) => {
            Core.loading(component, false);
            success (data);
        }).catch((data) => {
            Core.loading(component, false);
            error (data)
        });
    },

    addUnit (incidentId, unitId) {
        return Core.method.put(this.url.unit, null, incidentId, unitId);
    },

    removeUnit (incidentId, unitId) {
        return Core.method.delete(this.url.unit, null, incidentId, unitId);
    },

    save: function (component, json, success, error) {
        Core.method.put(this.url.create, json).then((data) => {
            Core.message.alert.save(component);
            success (data)
        }).catch((data) => {
            if (error) error (data)
        });
    },

    topAssessments (unitId) {
        return Core.method.get(this.url.assessment.top, unitId, 10)
    },

    postpone: function (id, postponement, success, error) {
        fetch(getApiBaseUrl() + this.url.postponement.replace("{0}", id),{
            method : "POST",
            headers: security.jsonHeader(),
            body   : JSON.stringify(postponement)
        })
            .then(data => security.response (data, error))
            .then(data => success (data))
            .catch(error => console.error(error))
    },

    delete: function (id, success) {
        fetch(getApiBaseUrl() + this.url.incident + id,{
            method : "DELETE",
            headers: security.jsonHeader() ,
        })
            .then(() => success (id))
            .catch((e) => {
                console.log(e);
            })
    },

    undelete: function (id, type, success) {
        fetch(getApiBaseUrl() + this.url.incident + id + "/undelete",{
            method : "PUT",
            headers: security.jsonHeader(),
            body   : JSON.stringify({
                typeId: type
            })
        })
            .then(() => success (id))
            .catch((e) => {
                console.log(e);
            })
    },

    changeType: function (id, type, success) {
        fetch(getApiBaseUrl() + this.url.incident + id,{
            method : "PUT",
            headers: security.jsonHeader(),
            body   : JSON.stringify({
                typeId: type
            })
        })
            .then(() => success (id))
            .catch((e) => {
                console.log(e);
            })
    },

    goto: function (component, incidentId, unitId, stepId, event) {
        Core.nav.push(component, "incident", { id: incidentId, unitId: unitId, stepId: stepId, event: event });
    },

    get (incidentId) {
        return Core.method.get(this.url.incidentId, incidentId);
    },

    refresh (component) {
        component.$root.$emit(this.events.journal);
    },

    style: {
        box (size) {
            return "width: " + size + "px;" + "height: " + size + "px;";
        },

        fileEntryFieldBackground (data) {
            return data && data.collection.length > 1 ? 'field-group-background-blue' : null;
        }
    },

    component: {
        icon (component) {
            switch (component.action) {
                case 'REPAIR'   : return "fas fa-tools";
                case 'CHANGE'   : return "fas fa-exchange-alt";
                case 'UNDEFINED': return 'fas fa-question';
            }

            return null;
        },
    }
}